import * as THREE from 'three';
import { box, cyl, sphere } from '../core/meshkit.js';

// Big T: a big grilled porkchop shopkeeper. Builds a 3D group from primitive shapes.
// Usage: const t = buildBigT(); scene.add(t);

export function buildBigT(){
  const g = new THREE.Group();

  // porkchop body: pink with charred edges
  const body = new THREE.Mesh(
    new THREE.CylinderGeometry(0.42, 0.32, 1.0, 14),
    new THREE.MeshLambertMaterial({ color: 0xC97F86 })
  );
  body.rotation.z = Math.PI / 2;
  body.position.y = 1.05;
  body.castShadow = true;
  g.add(body);

  // charred edge/crust band
  const edge = new THREE.Mesh(
    new THREE.CylinderGeometry(0.44, 0.34, 0.12, 14),
    new THREE.MeshLambertMaterial({ color: 0x5A2E1C })
  );
  edge.rotation.z = Math.PI / 2;
  edge.position.y = 1.05;
  g.add(edge);

  // grill marks
  for (let i = -2; i <= 2; i++){
    const mark = new THREE.Mesh(
      new THREE.BoxGeometry(0.06, 0.7, 0.02),
      new THREE.MeshLambertMaterial({ color: 0x7A3B22 })
    );
    mark.position.set(i * 0.14, 1.12, 0.38);
    g.add(mark);
  }

  // legs
  cyl(0.08, 0.08, 0.55, 0x5A2E1C, -0.18, 0.28, 0, g, 8);
  cyl(0.08, 0.08, 0.55, 0x5A2E1C,  0.18, 0.28, 0, g, 8);

  // arms
  const armL = cyl(0.07, 0.07, 0.42, 0xC97F86, -0.5, 1.0, 0, g, 8);
  armL.rotation.z = 0.6;
  const armR = cyl(0.07, 0.07, 0.42, 0xC97F86, 0.5, 1.0, 0, g, 8);
  armR.rotation.z = -0.6;

  // head / face area
  sphere(0.18, 0xC97F86, 0, 1.45, 0.18, g, 10);
  // shades
  box(0.28, 0.08, 0.04, 0x111111, -0.08, 1.48, 0.32, g);
  box(0.28, 0.08, 0.04, 0x111111,  0.08, 1.48, 0.32, g);
  box(0.08, 0.03, 0.02, 0x111111, 0, 1.48, 0.32, g);
  // smile
  box(0.16, 0.04, 0.02, 0x3A1A1A, 0, 1.35, 0.34, g);

  // backwards cap
  const cap = new THREE.Mesh(
    new THREE.SphereGeometry(0.22, 12, 12, 0, Math.PI * 2, 0, Math.PI / 2),
    new THREE.MeshLambertMaterial({ color: 0x35A7E0 })
  );
  cap.position.set(0, 1.58, -0.05);
  g.add(cap);
  box(0.22, 0.04, 0.18, 0x35A7E0, 0, 1.58, 0.14, g); // brim

  // gold chain
  const chain = new THREE.Mesh(
    new THREE.TorusGeometry(0.18, 0.025, 6, 16),
    new THREE.MeshLambertMaterial({ color: 0xF7C948 })
  );
  chain.position.set(0, 1.28, 0.18);
  chain.rotation.x = Math.PI / 2;
  g.add(chain);

  // BBQ sauce bottle in right hand
  const bottle = new THREE.Mesh(
    new THREE.CylinderGeometry(0.07, 0.08, 0.28, 8),
    new THREE.MeshLambertMaterial({ color: 0x9B2B1E })
  );
  bottle.position.set(0.66, 0.92, 0.18);
  bottle.rotation.z = -0.4;
  g.add(bottle);
  cyl(0.03, 0.03, 0.1, 0xFFD700, 0.72, 1.08, 0.18, g, 6).rotation.z = -0.4;

  return g;
}
